export const SupportEmail = () => (
  <a href="mailto:support@alphamap.com" target="_blank" rel="noreferrer">
    support@alphamap.com
  </a>
)
